import { shouldShowZipCodeFieldForTaxCalculation } from '@/utils/tax';
import { FeatureFlag } from '@/constants/featureFlags';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';

export const useShouldBlockExpressCheckoutButtons = () => {
  const { customer, pricing } = useContext(CheckoutContext);
  const { featureFlags } = useContext(CheckoutContext);
  const isUSAOrCanada = shouldShowZipCodeFieldForTaxCalculation(customer);
  const isTaxValid = pricing.priceBreakdown.isTaxValid;

  if (!featureFlags[FeatureFlag.COLLECT_FULL_ADDRESS] && isUSAOrCanada && isTaxValid) {
    return {
      shouldBlockExpressCheckoutButtons: false,
    };
  }

  if (!featureFlags[FeatureFlag.COLLECT_FULL_ADDRESS] && isUSAOrCanada && !isTaxValid) {
    return {
      shouldBlockExpressCheckoutButtons: true,
    };
  }

  return {
    shouldBlockExpressCheckoutButtons: false,
  };
};
